<script lang="ts">
	import { afterUpdate, beforeUpdate, createEventDispatcher, onMount } from 'svelte';
	import CaretRightIcon from '../icons/CaretRightIcon.svelte';

	export let headerText: string = '';
	export let shouldBeExpanded: boolean = false;
	let accordionElement: Element;

	afterUpdate(() => {
		toggle(shouldBeExpanded);
		
	});

	function toggle(shouldExpand: boolean) {
		const headerButtonElement: any = accordionElement.querySelector('.accordion-header');
		const content = headerButtonElement.nextElementSibling;
		const icon = headerButtonElement.querySelector(`#accordion-icon`);
		if (shouldExpand) {
			headerButtonElement.classList.add('active');
			icon.classList.add(`rotate-90`);
			icon.classList.add(`-rotate-90`);
			content.style.display = 'block';
		} else {
			headerButtonElement.classList.remove('active');
			icon.classList.remove(`rotate-90`);
			icon.classList.remove(`-rotate-90`);
			content.style.display = 'none';
		}
	}

	function toggleAccordion(event: Event) {
		const headerButtonElement: any = event.currentTarget;
		shouldBeExpanded = !headerButtonElement.classList.contains('active');		
		toggle(shouldBeExpanded);
	}
</script>

<article bind:this={accordionElement} class="accordion-item"
    {...$$restProps} >
	<button
		class="accordion-header w-full cursor-pointer flex flex-row mt-2 py-2 gap-4"
		on:click={toggleAccordion}
	>
		<div class="grow text-left"><h2>{headerText ?? ''}</h2></div>
		<div class="flex-none px-4">
			<CaretRightIcon id="accordion-icon" class="transform rotate-90 h-[24px]"></CaretRightIcon>
		</div>
	</button>
	<div class="accordion-content py-2">
		<slot />
	</div>
</article>

<style>
	.accordion-content {
		display: none;
	}
	.accordion-header:hover {
		background-color: var(--vv-grey-light);
	}
</style>
